import { render, staticRenderFns } from "./IconSectionText.vue?vue&type=template&id=3fc433dc&"
import script from "./IconSectionText.vue?vue&type=script&lang=js&"
export * from "./IconSectionText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fc433dc')) {
      api.createRecord('3fc433dc', component.options)
    } else {
      api.reload('3fc433dc', component.options)
    }
    module.hot.accept("./IconSectionText.vue?vue&type=template&id=3fc433dc&", function () {
      api.rerender('3fc433dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSectionText.vue"
export default component.exports